import { z } from "zod";
import { DefaultRangeSchema } from "./common";

export const PanelKindSchema = z.enum([
  "timeseries",
  "kpi",
  "table",
  "funnel",
  "doughnut",
  "bar",
]);
export type PanelKind = z.infer<typeof PanelKindSchema>;

export const PanelQuerySchema = z.object({
  metric: z.string(),
  params: z.record(z.unknown()).optional(),
});
export type PanelQuery = z.infer<typeof PanelQuerySchema>;

export const GridPosSchema = z.object({
  x: z.number(),
  y: z.number(),
  w: z.number(),
  h: z.number(),
});
export type GridPos = z.infer<typeof GridPosSchema>;

export const PanelSchema = z.object({
  id: z.string(),
  title: z.string(),
  kind: PanelKindSchema,
  query: PanelQuerySchema,
  gridPos: GridPosSchema,
});
export type Panel = z.infer<typeof PanelSchema>;

export const DashboardVariableSchema = z.object({
  name: z.string(),
  defaultValue: z.string().optional(),
});
export type DashboardVariable = z.infer<typeof DashboardVariableSchema>;

export const DashboardLayoutSchema = z.object({
  panels: z.array(PanelSchema),
  variables: z.array(DashboardVariableSchema).optional(),
  defaultRange: DefaultRangeSchema.optional(),
});
export type DashboardLayout = z.infer<typeof DashboardLayoutSchema>;

export const DashboardSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  ownerId: z.string(),
  name: z.string(),
  slug: z.string(),
  layout: DashboardLayoutSchema,
  shared: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Dashboard = z.infer<typeof DashboardSchema>;

export const DashboardsListSchema = z.array(DashboardSchema);
export type DashboardsList = z.infer<typeof DashboardsListSchema>;

const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]*$/;

export const CreateDashboardBodySchema = z.object({
  name: z.string().min(1).max(120),
  slug: z.string().min(1).max(80).regex(SLUG_PATTERN),
  layout: DashboardLayoutSchema,
  shared: z.boolean().optional(),
});
export type CreateDashboardBody = z.infer<typeof CreateDashboardBodySchema>;

export const UpdateDashboardBodySchema = CreateDashboardBodySchema.partial();
export type UpdateDashboardBody = z.infer<typeof UpdateDashboardBodySchema>;
